export default __webpack_public_path__ + "static/media/logo.74aee2cf.svg";